export const GIG_CARDS_LAZY_OFFSET = 8,
    GIG_CARDS_MOBILE_LAZY_OFFSET = 4,
    LIST_VIEW_CARDS_LAZY_OFFSET = 8,
    LISTINGS_DESKTOP_SIZE = 48;

export const LOGO_MAKER_BANNER_ROW = {
    DESKTOP: 5,
    TABLET: 4,
    MOBILE: 5,
};
